import { TicketMatrixWrapper } from "../../components";

import AuthService from "../../utilities/services/auth.service";

export default function TicketMatrixPage() {
  const organization = AuthService.getOrg()[0];
  return (
    <>
      <TicketMatrixWrapper organization={organization} />
    </>
  );
}
